/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Memory_DescriptionInputs */



/**
* | output |
* | --- |
* | "What you save here applies to all your future chats. You can edit or delete it at any time." |
*
* @param {Memory_DescriptionInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const memory_description = /** @type {((inputs?: Memory_DescriptionInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Memory_DescriptionInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Was du hier speicherst, gilt für alle künftigen Chats. Du kannst es jederzeit ändern oder löschen.")
	return /** @type {LocalizedString} */ ("What you save here applies to all your future chats. You can edit or delete it at any time.")
});